export const PORTAL_URL = "https://portal.kleipdata.co.uk";
